// Services/Actions/WordpressApi.js

import axios from "axios";

// Fetch main blog post function
export const getMainBlogPost = async () => {
  try {
    const response = await axios.get(
      "https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts?_embed&per_page=10"
    );
    const posts = response.data;

    const tagsResponse = await axios.get(
      "https://blognxa.wpcomstaging.com/wp-json/wp/v2/tags"
    );
    const tags = tagsResponse.data;

    const mainTag = tags.find((tag) => tag.slug === "main");
    if (!mainTag) {
      console.error("No 'main' tag found.");
      return null;
    }

    const mainPost = posts.find((post) => post.tags.includes(mainTag.id));

    if (mainPost) {
      let authorName =
        mainPost._embedded?.author?.[0]?.name || "Unknown Author";
      if (authorName === "carrie2bf05c5980") {
        authorName = "Nxatel Marketing";
      }
      if (authorName === "catom6c1fb5f222") {
        authorName = "Cato Mackenzie";
      }
      return {
        id: mainPost.id,
        slug: mainPost.slug,
        title: mainPost.title.rendered,
        date: new Date(mainPost.date).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        author: authorName,
      };
    }

    return null; // No post with the 'main' tag
  } catch (error) {
    console.error("Error fetching blog post:", error);
    return null;
  }
};

// Fetch articles from WordPress using axios
export const fetchArticlesFromWordpress = async () => {
  const { data } = await axios.get(
    "https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts?per_page=100&_embed"
  );

  return data.map((post) => {
    const terms = post._embedded?.["wp:term"]?.[0] || [];

    const categoryNames = terms.map((t) => t.name.trim());
    const categorySlugs = terms.map((t) => t.slug.trim());

    return {
      id: post.id,
      slug: post.slug === "all" ? null : post.slug,
      title: post.title.rendered,
      date: new Date(post.date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      categoryNames,
      categorySlugs,
      image:
        post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
        "../assets/images/Blog/test.webp",
      type: "article",
      excerpt: post.excerpt?.rendered.replace(/<a[^>]*>.*?<\/a>/g, "") || "",
    };
  });
};

// Fetch individual article by ID
export const fetchArticleById = async (articleId) => {
  try {
    const response = await axios.get(
      `https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts/${articleId}?_embed`
    );
    const data = response.data;

    const decodeHtml = (html) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    return {
      title: data.title.rendered,
      content: data.content.rendered,
      date: new Date(data.date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      image:
        data._embedded["wp:featuredmedia"]?.[0]?.source_url ||
        "../assets/images/Blog/test.webp",
      category: decodeHtml(
        data._embedded["wp:term"]?.[0]?.[0]?.name || "Uncategorized"
      ),
    };
  } catch (err) {
    console.error("Failed to fetch article:", err);
    throw new Error("Oops! Failed to load article. Please try again.");
  }
};

// Fetch a single article by its slug
export const fetchArticleBySlug = async (slug) => {
  try {
    const response = await axios.get(
      `https://blognxa.wpcomstaging.com/wp-json/wp/v2/posts?slug=${slug}&_embed`
    );
    const posts = response.data;
    if (!Array.isArray(posts) || posts.length === 0) {
      throw new Error("No post found with that slug");
    }
    const data = posts[0];

    const decodeHtml = (html) => {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    return {
      id: data.id,
      slug: data.slug,
      title: data.title.rendered,
      content: data.content.rendered,
      date: new Date(data.date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      image:
        data._embedded["wp:featuredmedia"]?.[0]?.source_url ||
        "../assets/images/Blog/test.webp",
      category: decodeHtml(
        data._embedded["wp:term"]?.[0]?.[0]?.name || "Uncategorized"
      ),
    };
  } catch (err) {
    console.error("Failed to fetch article by slug:", err);
    throw new Error("Oops! Failed to load article.");
  }
};
